module.exports = __webpack_public_path__ + "img/charging-hub-in-progress.e8fd4e9c.svg";